import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getLanguage } from "../../Utils/services";

export const CheckTabletOrder = ({ children }) => {
    const [isOrderOpen, setIsOrderOpen] = useState(true);
    const route = useSelector((state) => state.user.route)
    
    useEffect(() => {
        axios.get('/api/table/order/is_open')
            .then((data) => {
                if (data.data.useTabletOrder) {
                    setIsOrderOpen(true)
                    getLanguage('table');
                }
                else setIsOrderOpen(false)
            })
    }, [route])

    if (!isOrderOpen) {
        // user is not authenticated
        return <Navigate to="/req-tabletorder" />;
    }

    return children;
};